import { FC } from 'react'

import { useProductPaymentsQuery } from '@/screens/Product/hooks/use-product-payments-query'

import { CreditSelection, InstallmentSelection } from '@/features/payments/payment-selection'

import { AdaptedVariant } from '@/entities/Payments'

import { TPrice } from '@/shared/types/deprecated-types'

import { CreditTabSkeleton } from './skeleton/skeleton'

import cls from './credit-tab.module.scss'

export const PRODUCT_INSTALLMENT_SECTION_ID = 'productInstallment'
export const PRODUCT_CREDIT_SECTION_ID = 'productCredit'
export const OPEN_PRODUCT_CREDIT_TAB_EVENT = 'openProductCreditTab'

export interface CreditTabProps {
	installmentPrograms: string[]
	price: TPrice
	title: string
	productKod?: string
	productId?: number
	installmentData?: AdaptedVariant[]
	creditData?: AdaptedVariant[]
}

/**
 * Credit Tab Component
 * Section for displaying credit and installment payment options
 */
export const CreditTab: FC<Omit<CreditTabProps, 'title'>> = ({
	price,
	productKod,
	productId,
	installmentData,
	creditData
}): JSX.Element => {
	const { isLoading } = useProductPaymentsQuery(Number(productId))

	if (isLoading) {
		return (
			<section className={cls.root} style={{ marginBottom: `60px` }}>
				<CreditTabSkeleton />
			</section>
		)
	}

	return (
		<section className={cls.root}>
			{!!installmentData?.length && (
				<div id={PRODUCT_INSTALLMENT_SECTION_ID}>
					<InstallmentSelection
						installmentData={installmentData}
						price={price.VALUE}
						productId={productId}
						productKod={productKod}
					/>
				</div>
			)}

			{!!creditData?.length && (
				<div id={PRODUCT_CREDIT_SECTION_ID}>
					<CreditSelection creditData={creditData} price={price.VALUE} productId={productId} productKod={productKod} />
				</div>
			)}
		</section>
	)
}
